import { render } from "./MdTabsInline.vue?vue&type=template&id=cc360d3c&scoped=true&ts=true"
import script from "./MdTabsInline.vue?vue&type=script&lang=ts"
export * from "./MdTabsInline.vue?vue&type=script&lang=ts"

import "./MdTabsInline.vue?vue&type=style&index=0&id=cc360d3c&lang=scss&scoped=true"

import exportComponent from "/Users/alexanderclaas/Documents/Epic AI/ChatCaptain/chatcaptain-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc360d3c"]])

export default __exports__